import { inject, Injectable } from '@angular/core';
import { UseQuery } from '@ngneat/query';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export interface TalentPoolPlanRaw {
  id: number;
  type: 'professional' | 'executive_pro';
  term_months: number;
  price_per_month: string;
  currency: string;
  is_active: boolean;
  total_price: number;
  savings_percentage: number;
  vat_amount: number;
  total_with_vat: number;
}

export interface TalentPoolPlanPrice {
  id: number;
  duration_months: number;
  price_per_month: number;
  total_price: number;
  savings_percentage: number;
}

export interface TalentPoolPlan {
  type: 'professional' | 'executive_pro';
  prices: TalentPoolPlanPrice[];
}

export interface TalentPoolPlansResponse {
  data: {
    professional: TalentPoolPlanRaw[];
    executive_pro: TalentPoolPlanRaw[];
  };
}

export function transformPlans(raw: TalentPoolPlansResponse['data']): {
  professional: TalentPoolPlan;
  executive_pro: TalentPoolPlan;
} {
  const transform = (
    plans: TalentPoolPlanRaw[],
    type: 'professional' | 'executive_pro'
  ): TalentPoolPlan => ({
    type,
    prices: plans.map((p) => ({
      id: p.id,
      duration_months: p.term_months,
      price_per_month: parseFloat(p.price_per_month),
      total_price: p.total_price,
      savings_percentage: p.savings_percentage,
    })),
  });

  return {
    professional: transform(raw.professional || [], 'professional'),
    executive_pro: transform(raw.executive_pro || [], 'executive_pro'),
  };
}

@Injectable({
  providedIn: 'root',
})
export class TalentSearchPlansService {
  private useQuery = inject(UseQuery);
  private http = inject(HttpClient);

  getPlans() {
    return this.useQuery(['talent-search-plans'], () =>
      this.http.get<TalentPoolPlansResponse>(
        `${environment.apiUrl}talent-pool/plans`
      )
    );
  }
}
